import { render, staticRenderFns } from "./BrandOpportunities.vue?vue&type=template&id=726b3c85&scoped=true"
import script from "./BrandOpportunities.vue?vue&type=script&lang=js"
export * from "./BrandOpportunities.vue?vue&type=script&lang=js"
import style0 from "./BrandOpportunities.vue?vue&type=style&index=0&id=726b3c85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726b3c85",
  null
  
)

export default component.exports